import React from 'react';
//import {authRoles} from '../../auth';

export const TiposNotificacionesUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/tipos-notificaciones-details/:id',
        component: React.lazy(() =>
            import ('./TiposNotificacionesUpdate'))
    }]
};